export default {
  navigation: {
    next: "İleri",
    back: "Geri",
    surveyNavigation: "Anket gezintisi",
    workspace: {
      home: "Ana Sayfa",
      example: "Örnek"
    }
  }
}
